<template>

  <div>
    <div class="box box-danger">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t('pages.register.addNew')}}</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <form role="form">
        <div class="box-body">
          <div class="form-group">
            <label for="exampleInputEmail3">{{$t('pages.register.email')}}</label>
            <input v-model="email" type="email" class="form-control" id="inputEmail3" placeholder="*">
          </div>
          <div class="form-group">
            <label>{{$t('pages.register.username')}}</label>
            <input v-model="username" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label>{{$t('pages.register.name')}}</label>
            <input v-model="name" type="text" class="form-control" placeholder="*">
          </div>
          <div class="form-group">
            <label>{{$t('pages.register.surname')}}</label>
            <input v-model="surname" type="text" class="form-control" placeholder="*">
          </div>
          <div class="form-group">
            <label>{{$t('pages.register.studentId')}}</label>
            <input v-model="studentId" type="text" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label>{{$t('pages.register.newUserRole')}} </label>
            <div v-for="role in roleList" class="checkbox">
              <label>
                <input type="checkbox" :value="role.id" v-model="rolesSelected"> {{role.displayName}}
              </label>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button type="submit" class="btn btn-danger" @click.prevent="createUser">{{Add}}</button>
          <p class="help-block">{{createUserMsg}}</p>
        </div>
      </form>
    </div>
  </div>

</template>

<script>
  import Rest from './../../services/rest'
  export default {
    data () {
      return {
        email: '',
        username: '',
        name: '',
        surname: '',
        studentId: '',
        createUserMsg: '',
        roleList: [],
        rolesSelected: [],
        Add: this.$t('pages.buttons.add')
      }
    },
    methods: {
      createUser: function () {
        var postdata = {
          email: this.email,
          username: this.username,
          firstName: this.name,
          lastName: this.surname,
          studentId: this.studentId,
          roleIds: this.rolesSelected
        }
        return Rest.request('POST', '/users', postdata).then((data) => {
          this.createUserMsg = this.$t('pages.buttons.success')
        }).catch((err) => {
          this.createUserMsg = err.responseJSON['message']
          console.log(err)
        })
      },
      getRoles: function () {
        return Rest.request('GET', '/roles').then((data) => {
          this.roleList = data
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    mounted () {
      this.getRoles()
    }
  }
</script>

<style>
.form-group.required .control-label:after {
  content:"*";
  color:red;
}
</style>



// WEBPACK FOOTER //
// CreateUser.vue?28e04714